// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DummyTable from "../../../molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Input from "../../../html/Input.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__KkmLog from "./KkmLog.js";
import * as Buhta_cabinet__PageNav from "../../../molecules/PageNav.js";
import * as Buhta_cabinet__Table2 from "../../../molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(id) {
  return function (orgId) {
    return function (objectId) {
      return function (setObjectId) {
        return function (objectType) {
          return function (setObjectType) {
            const match = React.useState(function () {
                  return "";
                });
            const setSearchText = match[1];
            const searchText = match[0];
            const match$1 = React.useState(function () {
                  return 1;
                });
            const setPage = match$1[1];
            const page = match$1[0];
            const match$2 = React.useState(function () {
                  return false;
                });
            const setMaximizeLog = match$2[1];
            const maximizeLog = match$2[0];
            const func = Buhta_cabinet__Kassa.JournalLogService.grid;
            const match$3 = Buhta_core__GrpcState.useGrid((function (param) {
                    return Curry._2(func, param, id);
                  }), undefined);
            const dispatch = match$3[1];
            const grid = match$3[0];
            React.useEffect((function () {
                    const params_search = searchText === "" ? undefined : Stdlib__String.trim(searchText);
                    const params = {
                      search: params_search,
                      page: page,
                      filters: /* [] */0,
                      expand: /* [] */0
                    };
                    if (!(searchText.length > 1 || searchText.length === 0)) {
                      return ;
                    }
                    const debounce = setTimeout((function (param) {
                            Curry._3(dispatch, undefined, params, undefined);
                          }), 200);
                    return (function (param) {
                              clearTimeout(debounce);
                            });
                  }), [
                  searchText,
                  page
                ]);
            const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
            const header = objectId !== undefined ? ({
                  hd: {
                    name: "Действие",
                    style: ""
                  },
                  tl: {
                    hd: {
                      name: "Дата",
                      style: ""
                    },
                    tl: /* [] */0
                  }
                }) : ({
                  hd: {
                    name: "Действие",
                    style: ""
                  },
                  tl: {
                    hd: {
                      name: "Пользователь",
                      style: ""
                    },
                    tl: {
                      hd: {
                        name: "Дата",
                        style: "text-right"
                      },
                      tl: /* [] */0
                    }
                  }
                });
            const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */0 : Stdlib__List.mapi((function (i, log) {
                      const url = log.profile_userpic;
                      const userPic = url !== undefined ? url : StaticAsset.src("/static/icons/avatar.svg");
                      const action_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(log.action_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
                      const cells_0 = {
                        body: log.description,
                        style: ""
                      };
                      const cells_1 = {
                        hd: {
                          body: action_time,
                          style: ""
                        },
                        tl: /* [] */0
                      };
                      const cells = {
                        hd: cells_0,
                        tl: cells_1
                      };
                      const cells2_0 = {
                        body: log.description,
                        style: ""
                      };
                      const cells2_1 = {
                        hd: {
                          body: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-5 h-5 rounded-lg",
                                        src: userPic
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: log.profile_name
                                      })
                                ],
                                className: "flex gap-1"
                              }),
                          style: ""
                        },
                        tl: {
                          hd: {
                            body: action_time,
                            style: "justify-end"
                          },
                          tl: /* [] */0
                        }
                      };
                      const cells2 = {
                        hd: cells2_0,
                        tl: cells2_1
                      };
                      const cells$1 = objectId !== undefined ? cells : cells2;
                      const Key = String(i);
                      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
                                  cells: cells$1,
                                  onClick: (function (param) {
                                      if (log.object_type !== "kkm_money_placement") {
                                        Curry._1(setObjectId, (function (param) {
                                                return log.object_id;
                                              }));
                                        return Curry._1(setObjectType, (function (param) {
                                                      return log.object_type;
                                                    }));
                                      }
                                      
                                    })
                                }, Key);
                    }), grid.VAL);
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "w-5 h-5 ",
                                                alt: "search",
                                                src: StaticAsset.src("/static/icons/search.svg")
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                                className: "sm:text-base h-12",
                                                value: searchText,
                                                placeholder: "Поиск...",
                                                onChange: (function (value) {
                                                    Curry._1(setPage, (function (param) {
                                                            return 1;
                                                          }));
                                                    Curry._1(setSearchText, (function (param) {
                                                            return value;
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "flex items-center pl-6 w-full gap-1 border-gray-main border-b"
                                      }),
                                  typeof grid === "string" ? (
                                      grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                    ) : (
                                      grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: Stdlib__List.length(grid.VAL) > 0 ? JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                                                              header: header,
                                                              rows: rows,
                                                              styles: Cn.$plus(Cn.$plus("grid overflow-x-auto px-4 py-6 lg:p-0", Cn.on("grid-cols-journal-max", objectId === undefined)), Cn.on("grid-cols-2", objectId !== undefined))
                                                            }) : JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("img", {
                                                                      className: "w-10 h-10",
                                                                      src: StaticAsset.src("/static/icons/cashier-40.svg")
                                                                    }),
                                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                      className: "mt-6 text-default-gray",
                                                                      children: "Нет записей"
                                                                    })
                                                              ],
                                                              className: "flex flex-col items-center col-span-3 mt-84"
                                                            }),
                                                      className: "flex-1 overflow-auto"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                                                      page: page,
                                                      setPage: setPage,
                                                      currentRecords: currentRecords
                                                    })
                                              ]
                                            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                    )
                                ],
                                className: Cn.$plus("h-full flex flex-col w-full overflow-y-auto", Cn.on("hidden", maximizeLog))
                              }),
                          objectId !== undefined ? JsxRuntime.jsx(Buhta_cabinet__KkmLog.make, {
                                  onClose: (function (param) {
                                      Curry._1(setObjectId, (function (param) {
                                              
                                            }));
                                      Curry._1(setObjectType, (function (param) {
                                              return "";
                                            }));
                                      Curry._1(setMaximizeLog, (function (param) {
                                              return false;
                                            }));
                                    }),
                                  onMaximize: (function (value) {
                                      Curry._1(setMaximizeLog, (function (param) {
                                              return value;
                                            }));
                                    }),
                                  maximizeLog: maximizeLog,
                                  objectId: objectId,
                                  objectType: objectType,
                                  orgId: orgId,
                                  kkm: id
                                }) : null
                        ],
                        className: "flex w-full flex-1 overflow-y-auto"
                      });
          };
        };
      };
    };
  };
}

function KkmJournal(Props) {
  return Curry._4(make(Props.id)(Props.orgId), Props.objectId, Props.setObjectId, Props.objectType, Props.setObjectType);
}

const make$1 = KkmJournal;

export {
  make$1 as make,
}
/* Buhta_cabinet__DummyTable Not a pure module */
